import {
  Box,
  Button,
  FormControl,
  TextField,
} from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import HtmlTooltip from "common/pages/auth/components/HtmlTooltip";
import { passwordNoticeText } from "common/pages/auth/signUp/components/constModules";
import { setGlobalMessage } from "hooks/useGlobalMessage";
import { useAuth } from "hooks/useAuth";
import { InvitationAcceptFormData, InvitationAcceptFormSchema } from "./schema";

type Props = {
  setCompleteProcess: (value: boolean) => void;
};

export default function InvitationAcceptForm({ setCompleteProcess }: Props) {
  const { completeNewPassword } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<InvitationAcceptFormData>({
    resolver: zodResolver(InvitationAcceptFormSchema),
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const onSubmit = async (data: InvitationAcceptFormData) => {
    const result =  await completeNewPassword(data.password);
    if (result.success) {
      setCompleteProcess(true);
    } else {
      setGlobalMessage({
        message: `${result.message}`,
        severity: "error",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box>
        <FormControl
          fullWidth
          margin="normal"
        >
          <HtmlTooltip title={passwordNoticeText}>
            <TextField
              {...register("password")}
              type="password"
              variant="outlined"
              fullWidth
              label="パスワード"
              error={!!errors.password}
              helperText={errors.password?.message}
            />
          </HtmlTooltip>
        </FormControl>
        <FormControl
          fullWidth
          margin="normal"
        >
          <TextField
            {...register("confirmPassword")}
            type="password"
            variant="outlined"
            fullWidth
            label="パスワード（確認用）"
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
          />
        </FormControl>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 3, mb: 2 }}
          disabled={isSubmitting}
        >
          送信
        </Button>
      </Box>
    </form>
  )
}
